<template>
  <div v-if="isVisblePreloader" :class="{'active': isVisblePreloader}" class="spinner-wrapper">
    <b-spinner
        variant="primary"
        key="primarySpinner"
    ></b-spinner>
  </div>
</template>

<script>
import {BSpinner} from 'bootstrap-vue'

export default {
  name: "Spinner",
  components: {
    BSpinner
  },
  computed: {
    isVisblePreloader() {
      return this.$store.state.technical.isPreloaderVisible
    }
  }
}
</script>

<style lang="scss" scoped>
  .spinner-wrapper{
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(255, 255, 255, 0.3);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: -2;
    pointer-events: none;
    &.active{
      z-index: 99;
      pointer-events: all;
     }
  }
</style>
